<template>
	<fragment>
		<template v-if="!answered">
			<HeadingSVG class="unfixed" imgName="trivia" altText="Trivia" />
			<div class="wysiwyg-content desciption" v-html="question" />
			<div class="btn-container">
				<MarqueeButton
					v-for="answer in answers" :key="answer.id"
					class="answer trivia"
					:action="select(answer)"
				>
					{{ answer.text }}
				</MarqueeButton>
			</div>
		</template>
		<template v-else>
			<div class="wysiwyg-content desciption" v-html="explanation" />
			<TriviaResult :amount="result" :correct="outcome" />
			<MarqueeButton class="trivia" :action="$parent.complete">{{ button_text }}</MarqueeButton>
		</template>
	</fragment>
</template>

<script>
import HeadingSVG from '@/components/base/HeadingSVG';
import MarqueeButton from "@/components/base/MarqueeButton";
import TriviaResult from "@/components/game/spin/bummers/TriviaResult";

export default {
	name: 'Trivia',
	components: {
		HeadingSVG,
		MarqueeButton,
		TriviaResult,
	},
	props: {
		answers: {
			type: Array,
			required: true,
		},
		button_text: {
			type: String,
			required: true,
		},
		question: {
			type: String,
			required: true,
		},
		reward: {
			type: Number,
			required: true,
		},
		spinPenalty: {
			type: Number,
			required: true,
		},
	},
	data: () => ({
		answered: false,
		explanation: "",
		outcome: false,
		result: 0,
	}),
	methods: {
		select(answer) {
			return () => {
				this.$store.dispatch("game/bummers/active/trivia/answer", answer);
				this.answered = true;
				this.explanation = answer.explanation;

				if (answer.correct === true) {
					this.outcome = true;
					this.result = this.reward;
					this.$store.dispatch("sound/fx/play", { id: "trivia_correct" });
				} else {
					this.outcome = false;
					this.result = this.spinPenalty;
					this.$store.dispatch("sound/fx/play", { id: "trivia_incorrect" });
				}

				const eventAction = this.outcome === true ? 'Correct' : 'Incorrect';
				this.$store.dispatch("global/analytics/trackEvent", { ec: "InGame", el: "Trivia", ea: eventAction });
			};
		},
	},
	mounted() {
		this.$store.dispatch("sound/fx/play", { id: "audience_happy" });
	},
};
</script>

<style lang="scss" scoped>
	.btn-container {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.trivia { margin: 20px 0 0; }
</style>
